// extracted by mini-css-extract-plugin
export default {"nav":"TapArea_nav__9uGO-"};